import {
  CATEGORIES,
  CATEGORIES_FAIL,
  CATEGORIES_SUCCESS,
  GET_CATEGORIES,
  GET_CATEGORIES_FAIL,
  GET_CATEGORIES_SUCCESS,
  GET_SUBCATEGORIES,
  GET_SUBCATEGORIES_FAIL,
  GET_SUBCATEGORIES_SUCCESS,
} from "./actionTypes";

const INIT_STATE = {
  error: "",
  loading: false,
  categories: [],
  totalCategories: 0,
  category: {},
  newCategory: [],
  subCategory: [],
  totalSubcategories:0,
};

const Categories = (state = INIT_STATE, action) => {
  switch (action.type) {
    /* Get New Categories */
    case CATEGORIES:
    case GET_SUBCATEGORIES:
      return {
        ...state,
        loading: true,
      };

    case CATEGORIES_SUCCESS:
      return {
        ...state,
        loading: false,
        newCategory: action.payload || [],
      };
      case GET_SUBCATEGORIES_SUCCESS:
        return {
          ...state,
          loading: false,
          subCategory: action.payload || [],
          totalSubcategories:action.payload.totalCount || 0,
        };

    case CATEGORIES_FAIL:
      return {
        ...state,
        loading: false,
      };
    /* Get New Categories END */

    /* Get Categories */
    case GET_CATEGORIES:
      return {
        ...state,
        loading: true,
      };

    case GET_CATEGORIES_SUCCESS:
      return {
        ...state,
        categories: action.payload.data || [],
        totalCategories: action.payload.totalCount || 0,
        loading: false,
        error: "",
      };

    case GET_CATEGORIES_FAIL:
    case GET_SUBCATEGORIES_FAIL:
      return {
        ...state,
        error: action.payload,
        loading: false,
      };

    default:
      return state;
  }
};

export default Categories;
